import { ICrosshairPlugin } from '@/shared/Charting/LineChart/lineChart.types.ts'
import axes from '@/shared/Charting/axes'
import LineChart from '@/shared/Charting/LineChart'

const CrosshairPlugin: () => ICrosshairPlugin = () => ({
  chart: null,
  mouse: { x: 0, y: 0 },
  init(chart: LineChart) {
    this.chart = chart
  },
  onMouseMove(e) {
    const rect = this.chart.canvas.getBoundingClientRect()
    this.mouse.x = e.clientX - rect.left
    this.mouse.y = e.clientY - rect.top
    this.chart.render()
  },
  onMouseLeave() {
    this.mouse.x = -1
    this.mouse.y = -1
    this.chart.render()
  },
  onAfterRender(ctx) {
    if (
      this.mouse.y < this.chart.paddings.top ||
      this.mouse.y > this.chart.canvas.height - this.chart.paddings.bottom ||
      this.mouse.x < this.chart.paddings.left ||
      this.mouse.x > this.chart.canvas.width - this.chart.paddings.right
    ) {
      return
    }

    ctx.save()

    // Прицел
    ctx.strokeStyle = '#000000E0'
    ctx.setLineDash([1, 3])
    ctx.beginPath()
    ctx.moveTo(this.mouse.x, this.chart.paddings.top)
    ctx.lineTo(this.mouse.x, this.chart.canvas.height - this.chart.paddings.bottom)
    ctx.stroke()
    ctx.beginPath()
    ctx.moveTo(this.chart.paddings.left, this.mouse.y)
    ctx.lineTo(this.chart.canvas.width - this.chart.paddings.right, this.mouse.y)
    ctx.stroke()
    ctx.setLineDash([])

    // Легенды для каждой из осей
    // oX
    const xValue = this.chart.getXValue(this.mouse.x)
    const xLabel = axes.getReadableTimeLabel(xValue, this.chart.zoom.xMax - this.chart.zoom.xMin)
    ctx.moveTo(this.mouse.x, this.chart.canvas.height - this.chart.padding)

    ctx.fillStyle = '#000'
    ctx.fillRect(this.mouse.x - 40, this.chart.canvas.height - this.chart.paddings.bottom, 80, 24)

    ctx.font = '12px Inter'
    ctx.fillStyle = '#fff'
    ctx.textAlign = 'center'
    ctx.fillText(xLabel, this.mouse.x, this.chart.canvas.height - this.chart.paddings.bottom + 16, 75)

    // oY
    const yValue = this.chart.getYValue(this.mouse.y)
    const yLabel = yValue.toFixed(2)
    ctx.moveTo(this.chart.canvas.width - this.chart.paddings.right, this.mouse.y)

    ctx.fillStyle = '#000'
    ctx.fillRect(this.chart.canvas.width - this.chart.paddings.right, this.mouse.y - 12, 80, 24)

    ctx.fillStyle = '#fff'
    ctx.textAlign = 'center'
    ctx.fillText(yLabel, this.chart.canvas.width - this.chart.paddings.right / 2, this.mouse.y + 4, 75)

    ctx.restore()
  },
})

export default CrosshairPlugin
